/*
Ce module Vuex permet d'afficher un v-progress-circular
dans le component CvEdit afin d'afficher un loader pendant
que les différent éléments (persinfo, persum, edu, work) se chargent.
*/

import {
  LOADING_REINIT,
  LOADING_ADDELEM,
} from './types.js';

// le nombre actuel d'éléments qui se chargent
const nbElemTarget = 7;

const initialState = {
  loadingAll: false,
  nbElem: 0,
}

const getters = {
  getLoadingAllState: state => state.loadingAll,
}

const actions = {
  initLoading({ commit }) {
    commit(LOADING_REINIT);
  },
  
  loadingAddElem({ commit }) {
    commit(LOADING_ADDELEM)
  }

}

const mutations = {
  [LOADING_REINIT](state) {
    state.loadingAll = true;
    state.nbElem = 0;
  },

  [LOADING_ADDELEM](state) {
    state.nbElem += 1;
    if(state.nbElem >= nbElemTarget) { // >= au lieu de == au cas ou....
      state.loadingAll = false;
      console.log("GLOBAL state LOADING : " + state.nbElem + ' ' + state.loadingAll);
    } else {
      state.loadingAll = true;
      console.log("GLOBAL state LOADING : " + state.nbElem + ' ' + state.loadingAll);
    }
    
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
  

